import React from "react";

class DropdownYN extends React.Component {
  render() {
    return (
      <React.Fragment>
        <option></option>
        <option value="X">Sim</option>
        <option value=" ">Não</option>
      </React.Fragment>
    );
  }
}

export default DropdownYN;
